import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import './shared/styles/scrollbar.css'; // Импортируем глобальные стили скроллбара
import App from './app/App';
import reportWebVitals from './reportWebVitals';
import { ThemeProvider } from './shared/contexts/ThemeContext';
import { configureServices } from './shared/di/configureServices';
import './config/config.test'; // Тест конфигурации
import './services/signalRManager'; // Eager init SignalR (централизованный менеджер)

// Инициализируем DI контейнер
configureServices();

const root = ReactDOM.createRoot(
  document.getElementById('root') as HTMLElement
);

root.render(
  <React.StrictMode>
    <ThemeProvider>
      <App />
    </ThemeProvider>
  </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
